module.exports = __webpack_public_path__ + "static/img/propTechEfficiency.2f7c484d.png";